import { render, staticRenderFns } from "./HumanList.vue?vue&type=template&id=0b147750&"
import script from "./HumanList.vue?vue&type=script&lang=js&"
export * from "./HumanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports